import api from "../../../Component/axios";

export const useDownload = () => {
  const token = localStorage.getItem("@Token");
  const downloadExcel = async (fecha, campo, variedad, tipo) => {
    try {
      const response = await api.post(
        `api/pedido-empaque/orden_empaque/`,
        {
          fecha,
          campo,
          variedad,
          tipo: tipo,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + token,
          },
          responseType: "blob",
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  return { downloadExcel };
};
